<template>
  <v-container fluid align-center justify-center fill-height class="green lighten-4">
    <v-progress-circular
      :size="50"
      :color="corSelecionada"
      indeterminate
    ></v-progress-circular>
  </v-container>
</template>

<script>
import { classCores } from "@/global";

export default {
  data: () => ({
    corSelecionada: "",
    cores: classCores,
  }),
  methods: {
    getRandomInt(min, max) {
      min = Math.ceil(min);
      max = Math.floor(max);
      return Math.floor(Math.random() * (max - min)) + min;
    },
  },
  created() {
    this.corSelecionada = this.cores[this.getRandomInt(0, this.cores.length)];
  },
};
</script>
